import { DecisionStatusEnum } from '../types/types';
import { includesEnumValueForSet } from './enumlikeHandlers';

const PAUSED_DECISION_STATUSES = new Set([
  DecisionStatusEnum.Staged,
  DecisionStatusEnum.Paused,
  DecisionStatusEnum.SystemPaused,
]);

export const isOrderPaused = (ordDecisionStatus: DecisionStatusEnum): boolean => {
  return includesEnumValueForSet(PAUSED_DECISION_STATUSES, ordDecisionStatus);
};
